import { render, staticRenderFns } from "./ProjectClientAdd.vue?vue&type=template&id=6063b6b6&scoped=true"
import script from "./ProjectClientAdd.vue?vue&type=script&lang=js"
export * from "./ProjectClientAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063b6b6",
  null
  
)

export default component.exports